import { Checkbox, Icon, Spinner } from '@chakra-ui/react';
import { ReactComponent as InfoIcon } from 'resources/images/info.svg';
import { UploadStatus } from '../types';

interface UploadedProps {
  songGuid?: string;
  item?: {
    status: UploadStatus;
  };
}

export const Uploaded = ({ songGuid, item }: UploadedProps) => {
  const errorMsg = !songGuid
    ? 'Song is not found'
    : item?.status === 'failed'
    ? 'Upload failed'
    : null;

  if (errorMsg) {
    return (
      <Icon title={errorMsg} h={6} w={6} as={InfoIcon} color="textSubdued" />
    );
  }

  if (item?.status === 'loading') {
    return <Spinner />;
  }

  return (
    <Checkbox
      title={item ? 'Uploaded' : 'Not found'}
      isChecked
      isIndeterminate={!item}
    />
  );
};
